export class LeadIdService {

    constructor($window) {
        // setup callback to capture the leadId when the form is complete.
        this.$window = $window;
        if (window.jangl && window.jangl.lead_id_campaign) {
            // append script to body to load data and set callback.
            let script = document.createElement('script');
            script.id = 'LeadiDscript_campaign';
            script.type = 'text/javascript';
            script.async = true;
            script.src = '//create.lidstatic.com/campaign/' +  window.jangl.lead_id_campaign + '.js?snippet_version=2';
            $window.document.body.appendChild(script);
        }
    }

    init() {
        if (window.jangl && window.jangl.lead_id_campaign && this.$window.LeadiD) {
            this.$window.LeadiD.formcapture.init();
        }
    }

    getToken() {
        if (!(window.jangl && window.jangl.lead_id_campaign && this.$window.LeadiD)) return;
        return this.$window.LeadiD.token;
    }
}

LeadIdService.$inject = ['$window'];



// WEBPACK FOOTER //
// ./app/jornaya/leadidService.js